import React, { useLayoutEffect } from 'react';
import { each } from 'lodash';
import DesktopBAU from '../bau/desktop';
import { BAU } from '../common/plans_data';

const Cell1 = () => {
  useLayoutEffect(() => {
    each(BAU.plans, (plan) => {
      plan.taxPhrase = 'Taxes and fees excluded.';
    });
  }, []);

  return (<DesktopBAU />);
};

export default Cell1;
